import { useAppSelector } from '@/shared/hooks';
import { openInNewBrowserTab } from '@/shared/lib';

import { organizationModel } from '@/entities/organization';
import { userModel } from '@/entities/user';

import { billingModel } from '..';
import { getShopUrl } from '../lib';

export const usePurchasePrompt = () => {
  const currentUser = useAppSelector(userModel.selectors.selectCurrentUser);
  const hasActiveSubscriptionOrPackages = useAppSelector(
    billingModel.selectors.selectHasActiveSubscriptionOrPackages,
  );
  const billingZoneAndCountry = useAppSelector(
    billingModel.selectors.selectBillingZoneAndCountry,
  );
  const billingLoading = useAppSelector(billingModel.selectors.selectLoading);

  const isOwner =
    useAppSelector(
      organizationModel.selectors.selectIsUserOwner(currentUser.ID),
    ) ?? false;

  const isBillingLoaded = billingLoading === 'succeeded';

  const openShop = () => {
    const userEmail = currentUser?.PersonalData?.Emails?.[0] || '';
    const url = getShopUrl(userEmail);
    openInNewBrowserTab(url);
  };

  const isCISCluster = billingZoneAndCountry?.billingZone === 'CIS';

  const shouldShow =
    isBillingLoaded && isCISCluster && !hasActiveSubscriptionOrPackages;

  return {
    shouldShow,
    isOwner,
    isCISCluster,
    openShop,
  };
};
